/**
 * Het adres van het helpcenter - een eigen Pentrical-omgeving op een eigen
 * adres, dus overal een gewone externe link.
 *
 * VITE_HELP_URL blijft de knop voor wie een eigen helpcenter draait (of er
 * bewust géén wil tonen kan dat niet meer: er is altijd een werkend adres).
 * Zonder die variabele valt elke omgeving - ook lokaal - terug op het
 * publieke helpcenter, zodat de hulp-verwijzing nooit stilletjes ontbreekt.
 */
export const DEFAULT_HELP_URL = 'https://help.pentrical.com'

export function helpUrl(): string {
  return (import.meta.env.VITE_HELP_URL as string | undefined) || DEFAULT_HELP_URL
}
